export const EraserIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9C1.5 6.17157 1.5 4.75736 2.37868 3.87868C3.25736 3 4.67157 3 7.5 3H9.75C11.2221 3 11.9582 3 12.5917 3.31672C13.2251 3.63343 13.6667 4.22229 14.55 5.4C15.85 7.13333 16.5 8.00003 16.5 9C16.5 9.99997 15.85 10.8667 14.55 12.6C13.6667 13.7777 13.2251 14.3665 12.5917 14.6833C11.9582 15 11.2221 15 9.75 15H7.5C4.67157 15 3.25736 15 2.37868 14.1213C1.5 13.2427 1.5 11.8284 1.5 9Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M10.5 6.75L6 11.2497M10.5 11.25L6 6.75029"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
